/**
 * @author
 * David Rivera (jherax)
 * https://github.com/jherax
 */

import memoize from './fp/memoize';
import root from './root';

const DELAY = 30;
const MAX_INTENTS = 300; // 9 seconds

/**
 * @public
 * Gets an object when is loaded in the global scope.
 *
 * @param  {String} name: name of the object in the global scope
 * @return {Promise}
 */
function when(name) {
  let attempts = 0;
  return new Promise((resolve, reject) => {
    const timer = root.setInterval(() => {
      attempts += 1;
      if (Object.prototype.hasOwnProperty.call(root, name)) {
        root.clearInterval(timer);
        resolve(root[name]);
      } else if (attempts === MAX_INTENTS) {
        root.clearInterval(timer);
        reject(Error(`Failed to get "${name}"`));
      }
    }, DELAY);
  });
}

export default memoize(when);
